module.exports = __webpack_public_path__ + "static/media/patrol(21).01609187.PNG";